import type {
  WeeklyPlan,
  WeeklyPlanCarryoverCandidate,
} from "../../../shared/weekly-planning";

type Props = {
  plan: WeeklyPlan;
  carryovers: WeeklyPlanCarryoverCandidate[];
  selectedIds: string[];
  busy: boolean;
  onToggle: (
    candidate: WeeklyPlanCarryoverCandidate,
    selected: boolean,
  ) => void;
};
const number = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 });

export function WeeklyPlanningCarryovers({
  plan,
  carryovers,
  selectedIds,
  busy,
  onToggle,
}: Props) {
  return (
    <section
      className="weekly-planning-carryovers"
      aria-labelledby="weekly-plan-carryover-heading"
    >
      <header>
        <h3 id="weekly-plan-carryover-heading">Devreden işler</h3>
        <p>
          Önceki planlardan kalan üretimleri seçin. Kaynak iş ve kalan miktar
          korunur.
        </p>
      </header>
      {carryovers.length ? (
        <details className="weekly-planning-carryover-details">
          <summary>{carryovers.length} devreden işi göster</summary>
          <ul>
            {carryovers.map((candidate) => {
              const alreadyAdded = plan.rows.some(
                (row) => row.carryoverFromRowId === candidate.sourceRowId,
              );
              const blocked =
                !alreadyAdded &&
                (!candidate.canCarryOver ||
                  !candidate.unit ||
                  !candidate.capacityPerHour);
              return (
                <li key={candidate.sourceRowId}>
                  <label>
                    <input
                      type="checkbox"
                      checked={
                        alreadyAdded ||
                        selectedIds.includes(candidate.sourceRowId)
                      }
                      disabled={busy || blocked}
                      onChange={(event) =>
                        onToggle(candidate, event.target.checked)
                      }
                    />
                    <span>
                      <strong>{candidate.productName}</strong>
                      <small>
                        {candidate.lineName} ·{" "}
                        {candidate.workOrderNo ?? "İş emri yok"} ·{" "}
                        {number.format(candidate.remainingQuantity)}{" "}
                        {candidate.unit ?? "birim belirsiz"} kaldı
                      </small>
                      {candidate.blockedReason ? (
                        <em>{candidate.blockedReason}</em>
                      ) : blocked ? (
                        <em>
                          Birimi veya kapasitesi doğrulanamadığı için
                          devredilemez.
                        </em>
                      ) : null}
                    </span>
                  </label>
                </li>
              );
            })}
          </ul>
        </details>
      ) : (
        <p className="weekly-planning-empty">
          Bu hafta için devredecek açık üretim bulunmuyor.
        </p>
      )}
    </section>
  );
}
